// A5b: girişte profil tamamlatma kapısı. Sunucu /auth/me ve giriş yanıtında `profile_gate` döner ve korumalı
// işlemleri 409 PROFILE_COMPLETION_REQUIRED ile reddeder; bu dosya yalnız yönlendirmeyi yönetir.
export const PROFILE_GATE_CODE = 'PROFILE_COMPLETION_REQUIRED';
export const PROFILE_GATE_EVENT = 'mekandapro:profile-gate-required';
export const PROFILE_GATE_BAND = 'Devam etmeden önce profilindeki birkaç bilgiyi tamamlayalım — yaklaşık 2 dakika.';

export const PROFILE_PATHS = { venue: '/venue/profile', organizer: '/organizer/profile' };

// Kapı açıkken de kullanılabilen sayfalar: profil, taleplerim (okuma + hazır yanıt), eşleşmelerim ve sonuçlarım.
// Bildirimler ve çıkış her sayfanın üst çubuğundadır.
const ALLOWED = {
  venue: ['/venue/profile', '/venue/applications', '/venue/matches', '/venue/cooperation', '/venue/individual-requests'],
  organizer: ['/organizer/profile', '/organizer/applications', '/organizer/matches', '/organizer/cooperation'],
};

export const profileGateRequired = (user) => !!(user && PROFILE_PATHS[user.role] && user.profile_gate && user.profile_gate.required === true);

export const profilePath = (role) => PROFILE_PATHS[role] || '/';

export const isGateAllowedPath = (role, pathname = '') => {
  const path = String(pathname || '').replace(/\/+$/, '') || '/';
  return (ALLOWED[role] || []).some(prefix => path === prefix || path.startsWith(prefix + '/'));
};

export const isProfileGateError = (error) => {
  const detail = error && error.response && error.response.status === 409 && error.response.data && error.response.data.detail;
  return !!(detail && typeof detail === 'object' && detail.code === PROFILE_GATE_CODE);
};

// 409 yanıtından kapı nesnesi (eski sekmede kalan kullanıcı için).
export const gateFromError = (error) => {
  const detail = error.response.data.detail;
  return { required: true, reason: detail.reason || 'missing_core', missing: Array.isArray(detail.missing) ? detail.missing : [], pending_review: false };
};
